import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL_OLD,
  SUPPORT_GET_USER,
  SUPPORT_EDIT_USER,
  SUPPORT_GET_BET,
  SUPPORT_GET_BET_FAILED,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';
import { IGetUser, IEditUser } from '@/interface/User';

@Module({ name: 'user' })
export default class User extends VuexModule {
  @Action
  GetUser(params: IGetUser) {
    return Vue.axios({
      url: BASE_URL_OLD + SUPPORT_GET_USER,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action
  EditUser(params: IEditUser) {
    return Vue.axios({
      url: BASE_URL_OLD + SUPPORT_EDIT_USER,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action
  GetBet(params) {
    return Vue.axios({
      url: BASE_URL_OLD + SUPPORT_GET_BET,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action
  GetBetFailed(params) {
    return Vue.axios({
      url: BASE_URL_OLD + SUPPORT_GET_BET_FAILED,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }
}
